// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1HuVW","header":"styles_header__1vUSy","body":"styles_body__2_hxb","margin":"styles_margin__2kvm1"};